import React, { FC } from "react";
import LinkButton from "components/LinkButton";
import { useTranslation } from "react-i18next";
import {
  FooterCaption,
  FooterContent,
  FooterDot,
  FooterRow,
} from "./OutgoingSection.styles";

interface LoadMoreFooterProps {
  shown: number;
  total: number;
  pageSize: number;
  isLoading: boolean;
  onLoadMore: () => void;
  onShowAll: () => void;
}

// The list's last row while rows remain: the next page, the whole bucket
// when that is more than one page away, and how far along the list is.
// Renders nothing once every row is shown, or when the total is unknown.
const LoadMoreFooter: FC<LoadMoreFooterProps> = ({
  shown,
  total,
  pageSize,
  isLoading,
  onLoadMore,
  onShowAll,
}) => {
  const { t } = useTranslation("common");
  const remaining = total > shown ? total - shown : 0;

  if (!remaining) return null;

  return (
    <FooterRow>
      <FooterContent>
        <LinkButton disabled={isLoading} onClick={onLoadMore}>
          {t("parcels.showMore", { count: Math.min(remaining, pageSize) })}
        </LinkButton>
        {remaining > pageSize && (
          <>
            <FooterDot aria-hidden>·</FooterDot>
            <LinkButton disabled={isLoading} onClick={onShowAll}>
              {t("parcels.showAll", { count: total })}
            </LinkButton>
          </>
        )}
        <FooterDot aria-hidden>·</FooterDot>
        <FooterCaption>{t("parcels.shownOf", { shown, total })}</FooterCaption>
      </FooterContent>
    </FooterRow>
  );
};

export default LoadMoreFooter;
